if(document.getElementById('app_profil_set_notifications') != null){

    document.addEventListener('alpine:init', () => {

        Alpine.data('app_profil_set_notifications', (route, routeUpdate) =>({
            isFollower : false,
            loading : false,
            customerPros : [],
            route : '',
            init(){
                this.route = route;
                this.routeUpdate = routeUpdate;
                this.load();
            },
            load(){
                if(this.loading){
                    return;
                }
                this.loading = true;

                axios.get(route, {},{
                }).then(response =>{
                    this.prepapreCPS(response.data.customerPros)
                    this.loading = false;
                }).catch(thrown =>{
                    this.loading = false;
                  });
            },
            prepapreCPS(customerPros){

                for (let i = 0; i < customerPros.length; i++) {
                    let cp = customerPros[i];
                    cp.UI_show_update_success = false;
                }
                this.customerPros = customerPros;
            },
            updateNotificationSettings(pro_id, notificationType) {
                // Récupérer l'état actuel de la case à cocher
                const isChecked = event.target.checked;
                console.log({
                    pro_id: pro_id,
                    notificationType: notificationType,
                    isChecked: isChecked
                });

                // Effectuer une requête POST en fonction de l'état
                axios.post(this.routeUpdate, {
                    'pro_id': pro_id,
                    'notificationType': notificationType,
                    'isChecked': isChecked
                })
                .then(response => {
                    // Gérer la réponse si nécessaire
                    if(response.data.success){
                        this.updateCustomersPro(response.data.customerPro);
                    }
                })
                .catch(error => {
                    console.error('Erreur lors de la mise à jour des paramètres de notification', error);
                });
            },
            updateCustomersPro(newCP){
                for (let i = 0; i < this.customerPros.length; i++) {
                    let cp = this.customerPros[i];

                    if(newCP.id == cp.id){
                        if(newCP.accept_email_campagn != cp.accept_email_campagn){
                            cp.accept_email_campagn = newCP.accept_email_campagn;
                            cp.UI_show_update_success = true;setTimeout(() => cp.UI_show_update_success = false, 1000)
                        }
                        if(newCP.accept_sms_campagn != cp.accept_sms_campagn){
                            cp.accept_sms_campagn = newCP.accept_sms_campagn;
                            cp.UI_show_update_success = true;setTimeout(() => cp.UI_show_update_success = false, 1000)
                        }
                    }



                }
            }
        }))
    })

}
